import React from "react";

class Allergy extends React.Component {
    constructor(props) {
        super(props);
        this.allergyInitialValue = [
            { id: 1, status: false, tag: 'Drug/medical allergy' },
            { id: 2, status: false, tag: 'Food allergy' },
            { id: 3, status: false, tag: 'Latex allergy' },
            { id: 4, status: false, tag: 'Pollen allergy' },
            { id: 5, status: false, tag: 'Mold Allergy' },
            { id: 6, status: false, tag: 'Perfumes/household chemicals allergy' },
            { id: 7, status: false, tag: 'Pet/animal allergy' },
            { id: 8, status: false, tag: 'Dust mites' },
        ];

        this.handleCheckedOptions = (nextAllergy, status) => {
            this.allergyInitialValue.map(t => {
                if (t.id === nextAllergy.id) {
                    t.status = status
                    return nextAllergy;
                } else {
                    return t;
                }
            })
            props.ifAllergy(this.allergyInitialValue)
        };
        if (this.props.preSelected.length) {
            this.props.preSelected.map(allergy => {
                this.handleCheckedOptions(allergy, allergy.status)
            })
        }
    }
    render() {
        return (
            <div className="flex flex-col border mt-4 pl-4 rounded">
                <h1 className="my-5 text-gray-600">
                    Select from the given category1
                </h1>
                {this.allergyInitialValue.map((item, index) =>
                    <label className="mr-2 mb-4 flex items-center" key={`label-check${item.id}allergy`}>
                        <input
                            onChange={(e) => this.handleCheckedOptions(item, e.target.checked)}
                            checked={item.status}
                            type="checkbox"
                            id={`checkbox-items${index + item.tag}-tag`}
                            name={`${item.tag}`}
                            className="mr-1"
                        />
                        <span className="ml-1">{item.tag}</span>
                    </label>
                )}
            </div>
        );

    }
}

export default Allergy;